export default () => ({
  currentTeam: null
})
